import React from 'react';
import FormatDate from '../../models/helpers/formatDate.ts';

const FormDatePicker = ({
    entity,
    fieldName,
    handleInputChange,
    label,
    mb = 3,
    errors
}: {
    entity: any;
    fieldName: string;
    handleInputChange: any;
    label?: string;
    mb?: number;
    errors?: any;
}) => {
    const clearField = () => {
        handleInputChange({ target: { id: fieldName, value: null } });
    }

    return (
        <div className={`input-group has-validation ${mb && mb > 0 && `mb-${mb}`}`}>
            <div className={`form-floating ${errors?.[fieldName] && 'is-invalid'}`}>
                <input
                    type="date"
                    className={`form-control ${errors?.[fieldName] && 'is-invalid'}`}
                    id={fieldName}
                    value={FormatDate(entity[fieldName] || '')}
                    onChange={handleInputChange}
                    style={{
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    }}
                />
                <label htmlFor={fieldName}>{label ? label : fieldName}</label>
            </div>
            <span className="input-group-text" onClick={clearField}><i className="bi bi-x-lg"></i></span>
            {
                errors?.[fieldName] && (
                    <div className="invalid-feedback">
                        {errors?.[fieldName]}
                    </div>
                )
            }
        </div >
    );
};

export default FormDatePicker;